import { useTranslation } from "react-i18next";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import { FinecoButton } from "pages/assistant/components/FinecoButton";
import { GenerateReport } from "./GenerateReport";
import { FinecoDownloadButton } from "pages/assistant/components/FinecoDownloadButton";

type FinecoPortfolioButtonsProps = {
  generatingPdf: boolean;
  generatingExcel: boolean;
  generatingDownloadPdf: boolean;
  requestGeneratePdfAction: (
    reportSpec: any,
    fromReport?: boolean,
  ) => Promise<void>;
  requestGenerateExcel: () => void;
  handleSavePortfolio: () => void;
  handleEmailClick: () => void;
  setGeneratingDownloadPdf: (generating: boolean) => void;
  generateReportRef: React.RefObject<any>;
  artifact: any;
  threadId?: string;
  portfolioId?: string;
  portfolioData?: any;
};
export const FinecoPortfolioButtons: React.FC<FinecoPortfolioButtonsProps> = ({
  generatingPdf,
  generatingExcel,
  generatingDownloadPdf,
  requestGeneratePdfAction,
  requestGenerateExcel,
  handleSavePortfolio,
  handleEmailClick,
  setGeneratingDownloadPdf,
  generateReportRef,
  artifact,
  threadId,
  portfolioId,
  portfolioData,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonContainer}>
      <FinecoDownloadButton
        click={() => {
          setGeneratingDownloadPdf(true);
          generateReportRef.current.generate(false);
        }}
        copy={
          !generatingDownloadPdf
            ? t("generateReport.download")
            : t("generateReport.downloading")
        }
      />
      <FinecoDownloadButton
        click={requestGenerateExcel}
        copy={
          !generatingExcel
            ? t("actions.generateExcel")
            : t("actions.submitting")
        }
      />
      <FinecoButton
        click={handleEmailClick}
        copy={t("generateReport.sendViaMail").toUpperCase()}
        white={true}
      />
      <GenerateReport
        artifact={{
          financial_plan: artifact.data?.financial_plan,
          risk_profile: artifact.data?.risk_profile,
        }}
        onGenerate={requestGeneratePdfAction}
        ref={generateReportRef}
        threadId={threadId}
        portfolioId={portfolioId}
        portfolioData={portfolioData}
      >
        <div className={styles.generateReportButton}>
          {!generatingPdf
            ? t("generateReport.modify").toUpperCase()
            : t("generateReport.downloading").toUpperCase()}
        </div>
      </GenerateReport>
      <FinecoButton
        click={handleSavePortfolio}
        copy={t("actions.saveMyPortfolio").toUpperCase()}
      />
    </div>
  );
};
